<template>
    <div class="modal-wrapper auth-modal login-modal"
         :class="{hide: loggedIn || modals.register || modals.newPassword || modals.forgotPassword, newDesign: newDesign}">
        <div class="modal" :class="{hide: modals.otp, enlarge: enlargeAuthModals, 'auth-shake': shake}">
            <div class="logo" :style="{display: hideLogo ? 'none' : ''}">
                <img :src="logoComputed" :style="{height: logo.height, opacity: hideLogo ? 0 : 1}" :class="{hide: !logoComputed}" @error="errorHandler" alt=""/>
            </div>
            <div class="title" role="heading" aria-level="1">
                <i v-if="newDesign" class="material-icons" aria-hidden="true">person_outline</i>
                <span>{{ tokens.loginModal.loginToTradeRoom.toUpperCase() }}</span>
                <i v-if="!newDesign" class="material-icons" aria-hidden="true">lock</i>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-row">
                        <label for="login-email">{{ emailLabelComputed }}</label>
                        <input
                            id="login-email"
                            class="form-control"
                            :class="{'invalid-input': emailInvalid}"
                            name="email"
                            :autocomplete="ambient ? 'username' : 'off'"
                            inputmode="email"
                            autocapitalize="off"
                            spellcheck="false"
                            tabindex="1"
                            :aria-invalid="emailInvalid ? 'true' : null"
                            :aria-describedby="displayError ? 'login-error' : null"
                            v-model="email"
                            :placeholder="tokens.loginModal.enterEmail"
                            @keyup.enter="login"
                        />
                    </div>
                    <div v-if="!ambient" class="form-row" style="height:100%;"></div>
                    <!-- Classic two-column card: the link sits under the email column. The ambient
                         card is one column, where this spot is BETWEEN the fields - it renders
                         below Sign In instead (see .forgot-row). -->
                    <div v-if="!hideForgotPassword && !newDesign && !ambient" class="form-row">
                        <span class="forgot pointer" role="button" tabindex="5"
                              @click="showForgot" @keydown.enter.prevent="showForgot" @keydown.space.prevent="showForgot">{{
                                tokens.forgotPasswordModal.forgotPassword
                            }}</span>
                    </div>
                </div>
                <div class="col">
                    <div class="form-row">
                        <label for="login-password">{{ tokens.loginModal.password }}</label>
                        <div class="show-hide-password" :class="{'invalid-input': passwordInvalid}">
                            <input id="login-password" class="form-control pass" ref="password" name="password" :type="passwordFieldType"
                                   :autocomplete="ambient ? 'current-password' : 'off'" tabindex="2"
                                   :aria-invalid="passwordInvalid ? 'true' : null"
                                   :aria-describedby="displayError ? 'login-error' : null"
                                   v-model="password" :placeholder="tokens.loginModal.yourPassword" @keyup.enter="login"/>
                            <i class="material-icons pass-toggle"
                               role="button"
                               tabindex="3"
                               aria-controls="login-password"
                               :aria-label="passwordVisible ? tokens.loginModal.hide : tokens.widgetOrders.show"
                               :title="passwordVisible ? tokens.loginModal.hide : tokens.widgetOrders.show"
                               @mousedown.prevent
                               @click="togglePassword"
                               @keydown.enter.prevent="togglePassword"
                               @keydown.space.prevent="togglePassword">{{ passwordVisible ? 'visibility_off' : 'visibility' }}</i>
                        </div>
                    </div>
                    <div v-if="displayError" id="login-error" class="auth-error" role="alert">{{ displayError }}</div>
                    <div class="form-row signin-row" :class="{last: newDesign}">
                        <label class="spacer" aria-hidden="true">&nbsp;</label>
                        <div class="button green-button" role="button" tabindex="4"
                             :class="{'is-loading': submitting}"
                             :aria-busy="submitting ? 'true' : null"
                             :aria-disabled="submitting ? 'true' : null"
                             v-on:click="login"
                             @keydown.enter.prevent="login"
                             @keydown.space.prevent="login"
                             style="margin-top: 0">
                            <span class="button-label">{{ tokens.loginModal.signIn.toUpperCase() }}</span>
                        </div>
                    </div>
                    <div v-if="!hideForgotPassword && !newDesign && ambient" class="form-row forgot-row">
                        <button type="button" class="forgot-link" tabindex="5" @click="showForgot">
                            {{ tokens.forgotPasswordModal.forgotPassword }}
                        </button>
                    </div>
                    <div v-if="showToRegisterButton" class="form-row register">
                        <p v-if="!showRegisterModal">
                            {{ tokens.loginModal.dontHaveAccount }}
                            <a href="/register" tabindex="6">{{ tokens.fullScreenReferrals.registered }}</a>
                        </p>
                    </div>
                    <div v-if="!hideForgotPassword && newDesign" class="form-row footer">
                        <p>
                            {{
                                tokens.forgotPasswordModal.forgotPassword
                            }}
                            <span @click="showForgot">{{ tokens.loginModal.restore }}</span>
                        </p>
                        <p v-if="!showRegisterModal">
                            {{ tokens.loginModal.dontHaveAccount }}
                            <a href="/register">{{ tokens.fullScreenReferrals.registered }}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <TwoFactorAuthenticationModal :class="{hide: !modals.otp}" :email="this.email" :password="this.password"/>
    </div>
</template>

<script>
import {HIDE_FORGOT_PASSWORD, NEW_DESIGN, SHOW_REGISTER_MODAL} from "@/common/config";

import {mapGetters} from 'vuex'
import {LOGIN} from "@/store/actions.type";
import {MODAL, AUTH_ERROR, NOTIFICATION_ERROR} from "@/store/mutations.type";
import TwoFactorAuthenticationModal from "@/components/Modals/TwoFactorAuthenticationModal";
import {LOGO , HIDE_LOGO, WHITE_THEME,SHOW_TO_REGISTER_BUTTON,ENLARGE_AUTH_MODALS,AUTH_DESIGN} from "@/common/config"

export default {
    name: "LoginModal",
    components: {
        TwoFactorAuthenticationModal
    },
    data() {
        return {
            newDesign: NEW_DESIGN,
            hideForgotPassword: HIDE_FORGOT_PASSWORD,
            email: '',
            password: '',
            otp: '',
            passwordFieldType: 'password',
            showRegisterModal: SHOW_REGISTER_MODAL,
            // Classic two-column card: the spacer keeps the columns aligned. The ambient card is
            // single-column, where the spacer would only leave a gap.
            ambient: AUTH_DESIGN === 'ambient',
            logo: LOGO,
            hideLogo: HIDE_LOGO,
            whiteTheme: WHITE_THEME,
            showToRegisterButton: SHOW_TO_REGISTER_BUTTON,
            enlargeAuthModals: ENLARGE_AUTH_MODALS,
            localError: '',
            emailInvalid: false,
            passwordInvalid: false,
            // Ambient only: the button shows a spinner between the request and its answer, and a
            // second press is ignored. Cleared by the answer (error, 2FA step or login); the timer
            // is the backstop for a transport failure, which RestService.post reports to no one.
            submitting: false,
            submitTimer: null,
            shake: false,
            shakeTimer: null,
        }
    },
    methods: {
        togglePassword() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
        },
        stopSubmitting() {
            clearTimeout(this.submitTimer)
            this.submitting = false
        },
        login() {
            if (this.submitting) {
                return
            }

            // Same checks for every auth design: a well-formed email and a non-empty password
            // (the classic design used to send anything and wait for INVALID_LOGIN).
            const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email.trim())
            const passwordOk = this.password.trim().length > 0

            if (AUTH_DESIGN === 'ambient') {
                this.localError = ''
                this.$store.commit(AUTH_ERROR, '')
                this.emailInvalid = !emailOk
                this.passwordInvalid = !passwordOk
            }

            if (!emailOk || !passwordOk) {
                if (AUTH_DESIGN === 'ambient') {
                    this.localError = this.tokens.errors.INVALID_FIELDS
                    this.triggerShake()
                    // move the caret to the first field that needs attention
                    const first = emailOk ? 'login-password' : 'login-email'
                    this.$nextTick(() => { const el = document.getElementById(first); el && el.focus() })
                } else {
                    this.$store.commit(NOTIFICATION_ERROR, 'INVALID_FIELDS')
                }
                return
            }

            if (AUTH_DESIGN === 'ambient') {
                this.submitting = true
                clearTimeout(this.submitTimer)
                this.submitTimer = setTimeout(() => this.submitting = false, 8000)
            }

            // 2FA is a second step (TwoFactorAuthenticationModal), shown only when the backend
            // answers INVALID_CODE for an account that has it enabled.
            this.$store.dispatch(LOGIN, {
                email: this.email.trim(),
                password: this.password.trim()
            })
        },
        triggerShake() {
            clearTimeout(this.shakeTimer)
            this.shake = false
            this.$nextTick(() => {
                this.shake = true
                this.shakeTimer = setTimeout(() => this.shake = false, 500)
            })
        },
        showForgot() {
            this.$store.commit(MODAL, {
                forgotPassword: true
            })
        },
        errorHandler(){
            this.logo.url = ''
            this.hideLogo = 1
        },
    },
    computed: {
        ...mapGetters(['loggedIn', 'modals', 'tokens','lightTheme', 'authError']),
        displayError() {
            return this.localError || (this.tokens.errors[this.authError] || this.authError)
        },
        logoComputed() {
            let url = this.logo.url

            if(this.whiteTheme){
                return this.lightTheme ? url.replace(/white/, 'black') : url
            }else{
                return this.tradingViewTheme === 'Light' ? url.replace(/white/, 'black') : url
            }
        },
        emailLabelComputed(){
            return this.tokens.loginModal.email
        },
        passwordVisible() {
            return this.passwordFieldType === 'text'
        }
    },
    watch: {
        loggedIn(val) {
            if (val) {
                this.email = ''
                this.password = ''
                this.otp = ''
                this.passwordFieldType = 'password'
                this.stopSubmitting()
            }
        },
        email() {
            this.localError = ''
            this.emailInvalid = false
            if (this.authError) {
                this.$store.commit(AUTH_ERROR, '')
            }
        },
        password() {
            this.localError = ''
            this.passwordInvalid = false
            if (this.authError) {
                this.$store.commit(AUTH_ERROR, '')
            }
        },
        authError(val) {
            if (val) {
                this.stopSubmitting()
                this.triggerShake()
            }
        },
        'modals.otp'(open) {
            this.stopSubmitting()
            if (open) {
                this.passwordFieldType = 'password'
            }
        }
    }
}
</script>

<style scoped>
.modal-wrapper,
.modal-otp {
    display: flex;
    align-items: center;
    justify-content: center;
}

.newDesign .row {
    margin-bottom: 10px;
    flex-direction: column;
}

.newDesign .row .col {
    margin-right: 0;
}

.newDesign .last{
    margin-top: -20px;
}

.newDesign .modal-otp .modal {
    width: 400px;
}

.newDesign .modal-otp .modal label {
    color: var(--white);
}

.newDesign .modal {
    width: 290px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background: linear-gradient(151.15deg, rgba(155, 162, 187, 0.85) 1.95%, rgba(57, 57, 57, 0.85) 82.08%);
    border-radius: 10px;
    padding: 30px 40px;
    border: 1px solid #CECECE;
    z-index: 1100;
}

.newDesign .form-row {
    margin-bottom: 20px;
}

.newDesign .form-init {
    width: 100%;
    margin-bottom: 10px;
}

.newDesign ::placeholder {
    color: transparent;
}

.newDesign .title {
    justify-content: flex-start;
    gap: 5px;
}

.newDesign label {
    margin-bottom: 5px;
    color: var(--white);
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    display: inline-block;
}

.newDesign input {
    width: 100%;
    background: rgba(180, 180, 180, 0.3);
    border-radius: 5px;
    color: var(--white);
}

.newDesign .button {
    width: 100%;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
    cursor: pointer;
    background: #247243;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 5px;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
}

.newDesign .footer {
    align-items: center;
}

.newDesign .footer p {
    margin-bottom: 15px;
    color: rgba(255, 255, 255, 0.6);
}

.newDesign .footer p:first-child {
    font-weight: 300;
    font-size: 12px;
    line-height: 14px;
}

.newDesign .footer p:last-child {
    margin-bottom: 0;
    text-align: center;
}

.newDesign .footer span:last-child,
.newDesign .footer p a {
    text-decoration: underline;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: var(--white);
    margin-left: 5px;
    cursor: pointer;
}


.modal {
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: var(--background-dark);
    padding: 25px;
    border: 1px solid var(--border);
    z-index: 1100;
   
}

@media(min-width: 500px){
    .modal.enlarge{
        width: 650px;
        font-size: 16px;
        input{
            font-size: 16px;
            height: 40px;
        }
    }
}

.logo{
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        max-width: 100%;
        max-height: 80px;
        object-fit: contain;
        object-position: center;
    }
}

.title {
    color: var(--white-to-black);
    font-weight: 600;
    font-size: 1.1em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
}

.title i {
    font-size: 20px;
}

.col {
    flex: 1 1 50%;
    justify-content: flex-start;
}

.col:first-child {
    margin-right: 30px;
}

label {
    margin-bottom: 5px;
}

input {
    width: 100%;
}

.row {
    overflow: hidden;
    align-items: stretch;
    flex-wrap: nowrap;
}

.button {
    width: 100%;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
    font-weight: 600;
    cursor: pointer;
}

.forgot {
    border-bottom: 1px dashed var(--font);
    font-size: 11.3px;
}

.register{
    font-size: 11.3px;
}
.register a{
    border-bottom: 1px dashed var(--font);
    color: var(--font);
    text-decoration: none;
}

</style>
